export const getTourDescription = ({ guestTourDescription }) => guestTourDescription

export const getPassengerID = ({ guestTourDescription }) => guestTourDescription.passenger

export const isInitialized = ({ guestTourDescription }) => guestTourDescription.initialized
